import styled from "styled-components";
import { Button, Flex, Typography } from "antd";
import { COLORS } from "../../../utils/colors";

const { Text } = Typography;

export const PlayerShell = styled(Flex)`
  && {
    width: 100%;
    padding: 8px 14px;
    border: 1px solid ${COLORS.borderCard};
    border-radius: 999px;
    background: ${COLORS.surface};
  }
`;

export const PlayButton = styled(Button)`
  && {
    width: 38px;
    height: 38px;
    min-width: 38px;
    padding: 0;
    border-radius: 50%;
    border: none;
    background: ${COLORS.primary};
    color: ${COLORS.textOnPrimary};
    box-shadow: none;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover,
    &:focus {
      background: ${COLORS.primary} !important;
      color: ${COLORS.textOnPrimary} !important;
      opacity: 0.9;
      box-shadow: none !important;
    }
  }

  && .anticon {
    font-size: 15px;
    color: ${COLORS.textOnPrimary};
  }
`;

export const Waveform = styled(Flex)`
  && {
    flex: 1 1 auto;
    min-width: 0;
    height: 34px;
    cursor: pointer;
    overflow: hidden;
  }
`;

export const WaveBar = styled.span<{ $height: number; $played: boolean }>`
  flex: 1 1 auto;
  min-width: 0;
  height: ${({ $height }) => Math.round($height * 100)}%;
  margin: 0 1px;
  border-radius: 999px;
  background: ${({ $played }) => ($played ? COLORS.primary : COLORS.border)};
  transition: background 90ms ease;
`;

export const TimeLabel = styled(Text)`
  && {
    flex-shrink: 0;
    font-family: "Roboto", sans-serif;
    font-size: 11px;
    font-weight: 500;
    color: ${COLORS.textSubtle};
    font-variant-numeric: tabular-nums;
  }
`;

export const HiddenAudio = styled.audio`
  display: none;
`;
